<template>
  <div class="adm-field">
    <label class="adm-label">Doctors <span class="adm-req">*</span></label>
    <div v-if="doctors === null" class="adm-options">
      <div v-for="n in 2" :key="n" class="adm-option"><div class="adm-skeleton" style="width: 55%"></div></div>
    </div>
    <div v-else-if="!doctors.length" class="adm-alert adm-alert--warning">
      <i class="fas fa-exclamation-triangle"></i>
      <div>
        No doctors are assigned to this clinic yet.
        <button type="button" class="adm-link-btn" @click="$emit('go-clinics')">Assign doctors in Clinics</button>
      </div>
    </div>
    <div v-else class="adm-options">
      <label v-for="doctor in doctors" :key="doctor.doctorid" class="adm-option" :class="{ 'is-checked': modelValue.includes(doctor.doctorid) }">
        <input type="checkbox" :checked="modelValue.includes(doctor.doctorid)" @change="toggle(doctor.doctorid)" />
        <span class="adm-option__text">
          <span class="adm-option__title">{{ doctor.doctorname }}</span>
          <span class="adm-option__meta">{{ doctor.specialization || "—" }}</span>
        </span>
      </label>
    </div>
    <div v-if="error" class="adm-field__error">{{ error }}</div>
  </div>
</template>

<script>
export default {
  name: "DoctorPicker",
  props: {
    modelValue: { type: Array, required: true },
    doctors: { type: Array, default: null }, // null while loading
    error: { type: String, default: "" },
  },
  emits: ["update:modelValue", "go-clinics"],
  methods: {
    toggle(doctorid) {
      const next = this.modelValue.includes(doctorid)
        ? this.modelValue.filter(id => id !== doctorid)
        : [...this.modelValue, doctorid];
      this.$emit("update:modelValue", next);
    },
  },
};
</script>

<style scoped>
.adm-link-btn {
  border: 0;
  background: none;
  padding: 0;
  color: inherit;
  font-weight: 700;
  text-decoration: underline;
  cursor: pointer;
}
</style>
